<template>
    <div class="container" id="blog">
        <div class="row ">
            <div class="col-lg-4 col-12 text-start d-flex align-items-end title">
                <p>
                    Check Out What Is <span class="one">Trending</span> In Our Latest <span class="two">News</span> 
                </p>
            </div>
            <div class="col-lg-8 text-end d-none d-lg-block">
                <img class="img-fluid imgg" src="../assets/blog-dec.png" alt="">
            </div>
        </div>
        <div class="row">
            <div class="col-lg-7 col-12 ">
                <div class="image-par text-lg-start text-center">
                    <img class="img-fluid" src="../assets/big-blog-thumb.jpg" alt="">
                    <div class="carde text-start">
                        <ul class="d-flex justify-content-between ">
                            <li><i class="fa fa-calendar ab"></i> <p  class="d-inline">24 Mar 2021</p></li>
                            <li><i class="fa fa-users ab"></i> <p class="d-inline">Template</p></li>
                            <li><i class="fa fa-folder ab"></i> <p class="d-inline">Branding</p></li>
                        </ul>
                        <h3>SEO Agency & Digital Marketing</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur and sed doer ket eismod tempor incididunt ut labore et dolore magna...</p>
                        <button class="btn ">Discover More</button>
                    </div>
                    
                </div>
            </div>
            <div class="col-12 col-lg-5 text-start leff container">
                <div class="row  m-lg-0 mt-4">
                    <div class=" col-md-6 col-lg-6">
                        <div>
                            <i class="fa fa-calendar ab"></i>
                            <p class="d-inline ms-2">24 Mar 2021</p>
                            <h3 class="mt-2 mb-2">SEO Agency & Digital Marketing</h3>
                            <p>Lorem ipsum dolor sit amsecteturii and sed doer ket eismod...</p>
                        </div>
                    </div>
                    <div class=" text-lg-end text-center text-md-end col-lg-6 col-md-6 ">
                        <img class="img-fluid immg" src="../assets/blog-thumb-01.jpg" alt="">
                    </div>
                </div>
                <div class="row   mt-4">
                    <div class=" col-md-6 col-lg-6">
                        <div>
                            <i class="fa fa-calendar ab"></i>
                            <p class="d-inline ms-2">24 Mar 2021</p>
                            <h3 class="mt-2 mb-2">SEO Agency & Digital Marketing</h3>
                            <p>Lorem ipsum dolor sit amsecteturii and sed doer ket eismod...</p>
                        </div>
                    </div>
                    <div class=" text-lg-end text-center text-md-end col-lg-6 col-md-6 ">
                        <img class="img-fluid immg" src="../assets/blog-thumb-01.jpg" alt="">
                    </div>
                </div>
                <div class="row  mt-4">
                    <div class=" col-md-6 col-lg-6">
                        <div>
                            <i class="fa fa-calendar ab"></i>
                            <p class="d-inline ms-2">24 Mar 2021</p>
                            <h3 class="mt-2 mb-2">SEO Agency & Digital Marketing</h3>
                            <p>Lorem ipsum dolor sit amsecteturii and sed doer ket eismod...</p>
                        </div>
                    </div>
                    <div class=" text-lg-end text-center text-md-end col-lg-6 col-md-6 ">
                        <img class="img-fluid immg" src="../assets/blog-thumb-01.jpg" alt="">
                    </div>
                </div>
              
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'blog',
//        
 
    }
</script>

<style  scoped>
.imgg{
    max-width: 40%;
}
.title {
    font-weight: 600;
    font-size: 30px;
    color:black;

}
.immg{
    border-radius: 20px;
}
@media (max-width: 767px) {
    .immg{
        width:100%
    }
}
/*  start image par */
.image-par{
    position: relative;
}
/*  end image par */
/* start card  */
.carde {
    position: relative;;
    padding: 25px;
    background-color:rgb(255, 255, 255);
    border-radius: 20px;
    width:75%;
    bottom:40px;
    transition: all .9s; 
}
@media (max-width: 992px) {
    .carde{
        width: 100%;
        margin-left:auto;
        margin-right:auto;
        
    }
        .imgg{
            min-width: 100%;
        }
}
@media (min-width: 770px) and (max-width:992px ) {
    .carde {
            width: 83%;
            margin-left: auto;
            margin-right: auto;
    
        }
}
.carde ul{
    list-style: none;
    padding: 0;
}
.carde ul p {
    color:#afafaf;
    font-size: 15px;
    font-weight: 300;
    margin-left: 10px;
}
.carde ul li .ab{
    color:#fe3f40 !important;
}
.carde h3,
.leff h3   {
    font-weight: 600;
    color: black;
    font-size: 15px;
}
.carde .btn {
    background-color:#03a4ed;
    color:white;
    margin-top:20px;
}
/* end card  */
/* start title */
.title .one {
    color: #03a4ed;
}
.title .two {
    color: #fe3f40;
}
.leff .ab {
    color: #fe3f40;
}
.leff .di-inline {
    color: #afafaf
}
</style>